import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/payroll/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/payroll/payslips" });
  },
});
